import { useSyncExternalStore } from 'react';
import type { VerifyPhoneOffer } from './use-credits-widget-state';

/**
 * Which daily-limit offer has its "Verify with WhatsApp" dialog open, if any. Module state rather than a
 * route param: the dialog is mounted ONCE at the frame (`AppFrame`, beside `PhoneVerifyModal`) while the
 * offer's button lives on three widgets (banner, chat card, menu card), and the dialog needs the offer's
 * numbers, which are not a URL's business.
 */
let open: VerifyPhoneOffer | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function openVerifyWhatsappDialog(offer: VerifyPhoneOffer): void {
  open = { limit: offer.limit, current: offer.current };
  emit();
}

export function closeVerifyWhatsappDialog(): void {
  if (!open) return;
  open = null;
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useVerifyWhatsappDialog(): VerifyPhoneOffer | null {
  return useSyncExternalStore(subscribe, () => open, () => null);
}
